import { render, staticRenderFns } from "./discordTech.vue?vue&type=template&id=43839caf&scoped=true"
import script from "./discordTech.vue?vue&type=script&lang=js"
export * from "./discordTech.vue?vue&type=script&lang=js"
import style0 from "./discordTech.vue?vue&type=style&index=0&id=43839caf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43839caf",
  null
  
)

export default component.exports